// import { useEffect, useState } from "react";
// import { IconChevronDown, IconX } from "@tabler/icons-react";
// import Input from "../../../components/Input";
// import {
//   Control,
//   Controller,
//   useForm,
//   UseFormClearErrors,
// } from "react-hook-form";
// import toast from "react-hot-toast";
// import { useShelfRowBayBinCreateMutation } from "../../../hooks/shelveHooks";

// interface CustomSelectProps {
//   namePrefix: string;
//   nameNumber: string;
//   control: any;
//   labeltext: string;
//   options: string[];
//   error?: string;
//   placeholder?: string;
//   isSelected?: boolean;
// }

// const CustomSelect: React.FC<CustomSelectProps> = ({
//   namePrefix,
//   nameNumber,
//   control,
//   labeltext,
//   options,
//   error,
//   placeholder = "Select...",
//   isSelected = false,
// }) => {
//   const [open, setOpen] = useState(false);

//   return (
//     <div className="space-y-1">
//       <div className="flex items-center justify-between px-4 py-1.5 text-sm rounded-full border border-gray-200 bg-white gap-2">
//         <Controller
//           name={namePrefix}
//           control={control}
//           rules={{
//             required: isSelected ? `${labeltext} type is required` : false,
//           }}
//           render={({ field }) => (
//             <input
//               type="text"
//               value={field.value || ""}
//               placeholder="Type"
//               maxLength={3}
//               onChange={(e) => field.onChange(e.target.value)}
//               className="focus:outline-none w-16 text-sm"
//             />
//           )}
//         />
//         <Controller
//           name={nameNumber}
//           control={control}
//           rules={{
//             required: isSelected ? `${labeltext} number is required` : false,
//           }}
//           render={({ field }) => (
//             <div className="relative">
//               <button
//                 type="button"
//                 className="w-20 flex justify-between items-center border border-gray-300 rounded-lg p-2 py-0.5 bg-white text-gray-700 gap-1"
//                 onClick={() => setOpen(!open)}
//               >
//                 <span className="font-medium text-[#212121] text-xs">
//                   {field.value || placeholder}
//                 </span>
//                 <IconChevronDown
//                   className={`w-3 h-3 transition-transform ${open ? "rotate-180" : ""}`}
//                 />
//               </button>
//               {open && (
//                 <ul className="absolute border-slate-300 border right-0 z-50 w-24 mt-1 bg-white rounded-lg shadow-xl max-h-40 overflow-auto">
//                   {options.map((opt, idx) => (
//                     <li
//                       key={idx}
//                       onClick={() => {
//                         field.onChange(opt);
//                         setOpen(false);
//                       }}
//                       className="px-3 py-2 text-xs cursor-pointer hover:bg-yellow-50"
//                     >
//                       {opt}
//                     </li>
//                   ))}
//                 </ul>
//               )}
//             </div>
//           )}
//         />
//       </div>
//       {error && <p className="text-red-500 text-[10px] pl-2">{error}</p>}
//     </div>
//   );
// };

// interface BinFormData {
//   selected: boolean;
//   level: string;
//   binType: string;
//   binNumber: string;
//   rackLevelId?: string; // Storing the ID for the payload
// }

// interface FormData {
//   bins: BinFormData[];
// }

// interface CreateBinsModalProps {
//   open: boolean;
//   onClose: () => void;
//   clearErrors?: UseFormClearErrors<any>;
//   rackLevels: {
//     rackLevels: Array<{ id: string; name: string }>;
//   };
//   rackInstanceId?: string;
//   shelveId: string;
//   warehouseId: string;
//   clientId: string;
//   storageType: string;
//   fetchShelves: () => void;
// }

// export default function CreateBinsModal({
//   open,
//   onClose,
//   rackLevels,
//   shelveId,
//   warehouseId,
//   clientId,
//   storageType,
//   fetchShelves,
//   rackInstanceId,
// }: CreateBinsModalProps) {
//   const { mutate: createRackBins, isPending } = useShelfRowBayBinCreateMutation();

//   const {
//     handleSubmit,
//     register: formRegister,
//     control: formControl,
//     watch: formWatch,
//     setValue: formSetValue,
//     reset,
//     formState: { errors: formErrors },
//   } = useForm<FormData>({
//     defaultValues: {
//       bins: [],
//     },
//   });

//   // Effect to initialize the table rows based on the rack levels provided
//   useEffect(() => {
//     if (open && rackLevels?.rackLevels) {
//       const initialBins = rackLevels.rackLevels.map((level: any) => ({
//         selected: false,
//         level: level.name,
//         rackLevelId: level.id,
//         binType: "",
//         binNumber: "",
//       }));
//       formSetValue("bins", initialBins);
//     }
//   }, [open, rackLevels, formSetValue]);

//   const onSubmit = (data: FormData) => {
//     const selectedBins = data.bins.filter((bin) => bin.selected);

//     if (selectedBins.length === 0) {
//       toast.error("Please select at least one level to add bins.");
//       return;
//     }

//     const payload = {
//       rackInstanceId, // Using the new Rack terminology
//       warehouseId,
//       shelveId,
//       clientId,
//       // storageType: storageType === "SHELVES" ? "B2C" : "B2B",
//       bins: selectedBins.map((bin) => ({
//         rackLevelId: bin.rackLevelId,
//         rackLevel: bin.level,
//         binType: bin.binType,
//         binNumbers: bin.binNumber,
//       })),
//     };

//     createRackBins(payload as any, {
//       onSuccess: () => {
//         toast.success("Bins created successfully!");
//         reset();
//         onClose();
//         fetchShelves();
//       },
//       onError: (err: any) => toast.error(`Error: ${err?.message || "Failed to create"}`),
//     });
//   };

//   if (!open) return null;

//   return (
//     <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
//       <form
//         onSubmit={handleSubmit(onSubmit)}
//         className="bg-[#F7F6F2] rounded-3xl w-[650px] max-h-[90vh] flex flex-col shadow-2xl"
//       >
//         <div className="flex items-center justify-between px-6 py-4 border-b bg-white rounded-t-3xl">
//           <h2 className="text-lg font-semibold text-[#212121]">Configure Bins</h2>
//           <button
//             type="button"
//             onClick={onClose}
//             className="p-2 rounded-full hover:bg-gray-100 border border-gray-200 transition-colors"
//           >
//             <IconX size={18} />
//           </button>
//         </div>

//         <div className="flex-1 p-6 overflow-y-auto">
//           <div className="bg-white border border-gray-200 rounded-xl overflow-hidden">
//             <table className="w-full text-left border-collapse">
//               <thead>
//                 <tr className="bg-gray-50 border-b border-gray-200">
//                   <th className="px-4 py-3 text-xs font-bold text-gray-500 uppercase tracking-wider w-16 text-center">
//                     Add
//                   </th>
//                   <th className="px-4 py-3 text-xs font-bold text-gray-500 uppercase tracking-wider">
//                     Rack Level
//                   </th>
//                   <th className="px-4 py-3 text-xs font-bold text-gray-500 uppercase tracking-wider">
//                     Bin Configuration
//                   </th>
//                 </tr>
//               </thead>
//               <tbody className="divide-y divide-gray-100">
//                 {formWatch("bins")?.map((bin, idx) => (
//                   <tr key={idx} className={`hover:bg-slate-50 transition-colors ${formWatch(`bins.${idx}.selected`) ? 'bg-yellow-50/30' : ''}`}>
//                     <td className="px-4 py-3 text-center">
//                       <input
//                         type="checkbox"
//                         {...formRegister(`bins.${idx}.selected`)}
//                         className="h-5 w-5 cursor-pointer accent-yellow-400 rounded"
//                       />
//                     </td>
//                     <td className="px-4 py-3">
//                       <span className="font-medium text-gray-700">{bin.level}</span>
//                       <input type="hidden" {...formRegister(`bins.${idx}.level`)} />
//                     </td>
//                     <td className="px-4 py-3">
//                       <CustomSelect
//                         namePrefix={`bins.${idx}.binType`}
//                         nameNumber={`bins.${idx}.binNumber`}
//                         control={formControl}
//                         labeltext="Bin"
//                         options={["1", "2", "3", "4", "5", "10"]}
//                         error={
//                           formErrors.bins?.[idx]?.binNumber?.message ||
//                           formErrors.bins?.[idx]?.binType?.message
//                         }
//                         isSelected={formWatch(`bins.${idx}.selected`)}
//                       />
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         </div>

//         <div className="flex justify-end items-center gap-3 px-6 py-4 border-t bg-white rounded-b-3xl">
//           <button
//             type="button"
//             onClick={onClose}
//             className="px-5 py-2 text-sm font-medium text-gray-600 hover:text-gray-800"
//           >
//             Cancel
//           </button>
//           <button
//             type="submit"
//             disabled={isPending}
//             className="px-8 py-2.5 rounded-full bg-[#FBD037] text-black font-bold text-sm shadow-md hover:bg-yellow-400 active:scale-95 transition-all disabled:opacity-50 disabled:pointer-events-none"
//           >
//             {isPending ? "Saving..." : "Create Bins"}
//           </button>
//         </div>
//       </form>
//     </div>
//   );
// }

import { useEffect, useState } from "react";
import { IconChevronDown, IconX } from "@tabler/icons-react";
import { Controller, useForm } from "react-hook-form";
import toast from "react-hot-toast";
import {
  useRackLevelBinsCreateMutation,
  useRackLevelBinsUpdateMutation,
  useFetchShelfRowWhRows,
} from "../../../hooks/shelveHooks";
import {
  useRackLevelPalletsCreateMutation,
  useRackLevelPalletsUpdateMutation,
} from "../../../hooks/shelveHooks";
import NewSelectInput from "../../../components/NewSelectInput";
import { useLanguage } from "../../../context/LanguageContext";

/* ================== Custom Select ================== */

interface CustomSelectProps {
  namePrefix: string;
  nameNumber: string;
  control: any;
  labeltext: string;
  options: string[];
  error?: string;
  placeholder?: string;
  isSelected?: boolean;
}

const CustomSelect: React.FC<CustomSelectProps> = ({
  namePrefix,
  nameNumber,
  control,
  labeltext,
  options,
  error,
  placeholder = "Select...",
  isSelected = false,
}) => {
  const [open, setOpen] = useState(false);
  const { t } = useLanguage();

  return (
    <div className="space-y-1">
      <div className="flex items-center justify-between px-4 py-2 text-sm rounded-full border border-gray-200 bg-white gap-2">
        <Controller
          name={namePrefix}
          control={control}
          rules={{
            required: isSelected ? t(`${labeltext} type is required`) : false,
            maxLength: {
              value: 3,
              message: t("Max 3 characters"),
            },
          }}
          render={({ field }) => (
            <input
              type="text"
              value={field.value || ""}
              placeholder={t("Type")}
              maxLength={3}
              onChange={(e) => field.onChange(e.target.value)}
              className="focus:outline-none w-16 text-sm"
            />
          )}
        />

        <Controller
          name={nameNumber}
          control={control}
          rules={{
            required: isSelected ? t(`${labeltext} number is required`) : false,
          }}
          render={({ field }) => (
            <div className="relative">
              <button
                type="button"
                className="w-20 flex justify-between items-center border border-gray-300 rounded-lg p-2 py-0.5 bg-white text-gray-700 gap-1"
                onClick={() => setOpen(!open)}
              >
                <span className="font-medium text-[#212121] text-xs">
                  {field.value || t(placeholder)}
                </span>
                <IconChevronDown
                  className={`w-3 h-3 transition-transform ${
                    open ? "rotate-180" : ""
                  }`}
                />
              </button>

              {open && (
                <ul className="absolute border-slate-300 border right-0 z-50 w-24 mt-1 bg-white rounded-lg shadow-xl max-h-40 overflow-auto">
                  {options.map((opt, idx) => (
                    <li
                      key={idx}
                      onClick={() => {
                        field.onChange(opt);
                        setOpen(false);
                      }}
                      className="px-3 py-2 text-xs cursor-pointer hover:bg-yellow-50"
                    >
                      {opt}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          )}
        />
      </div>

      {error && <p className="text-red-500 text-xs pl-2">{t(error)}</p>}
    </div>
  );
};

/* ================== Types ================== */

interface BinFormData {
  selected: boolean;
  level: string;
  binType: string;
  binNumber: string;
  rackLevelId?: string;
}

interface FormData {
  selectedType: string;
  selectedRack: number | ""; // ✅ FIXED TYPE
  bins: BinFormData[];
}

interface CreateBinsModalProps {
  open: boolean;
  onClose: () => void;
  rackLevels: {
    rackLevels: Array<{
      id: string;
      name: string;
      bin?: any[];
      pallet?: any[];
    }>;
  };
  rackInstanceId?: string;
  shelveId: string;
  warehouseId: string;
  areaId: string;
  clientId: string;
  storageType: string;
  fetchShelves: () => void;
  rowId?: string; // Add rowId prop
  preselectedLevelId?: string;
  preselectedType?: "bins" | "pallets";
}

/* ================== Main Component ================== */

const UserTypeData = [
  { id: 1, value: "bins", text: "Bins" },
  { id: 2, value: "pallets", text: "Pallets" },
];

export default function CreateBinsModal({
  open,
  onClose,
  rackLevels,
  shelveId,
  warehouseId,
  areaId,
  clientId,
  fetchShelves,
  rackInstanceId,
  rowId,
  preselectedLevelId,
  preselectedType,
}: CreateBinsModalProps) {
  const { t } = useLanguage();
  const { mutate: createRackBins, isPending: isBinsPending } =
    useRackLevelBinsCreateMutation();
  const { mutate: updateRackBins, isPending: isBinsUpdatePending } =
    useRackLevelBinsUpdateMutation();
  const { mutate: createRackPallets, isPending: isPalletsPending } =
    useRackLevelPalletsCreateMutation();
  const { mutate: updateRackPallets, isPending: isPalletsUpdatePending } =
    useRackLevelPalletsUpdateMutation();

  const isPending =
    isBinsPending ||
    isPalletsPending ||
    isBinsUpdatePending ||
    isPalletsUpdatePending;

  const {
    handleSubmit,
    register,
    control,
    watch,
    setValue,
    reset,
    formState: { errors },
  } = useForm<FormData>({
    defaultValues: {
      selectedType: "",
      selectedRack: "",
      bins: [],
    },
  });

  const bins = watch("bins");
  const selectedRack = watch("selectedRack");
  const selectedType = watch("selectedType");
  const selectedIndex = selectedRack === "" ? null : Number(selectedRack);

  // Check if selected rack level has existing bins or pallets
  const getExistingTypeForSelectedLevel = () => {
    if (selectedIndex === null || !rackLevels) return null;

    const levelsArray = rackLevels.rackLevels || rackLevels;
    const selectedLevel = levelsArray[selectedIndex] as any;

    if (!selectedLevel) return null;

    // Check if level has pallets (based on the data structure seen in ShelveLocationTab)
    if (selectedLevel.pallet && selectedLevel.pallet.length > 0) {
      return "pallets";
    }

    // Check if level has bins (assuming similar structure)
    if (selectedLevel.bin && selectedLevel.bin.length > 0) {
      return "bins";
    }

    return null;
  };

  const existingType = getExistingTypeForSelectedLevel();
  console.log("existingType", existingType);
  console.log("selectedType", selectedType);
  // Auto-set selectedType when existingType is found
  useEffect(() => {
    if (existingType && selectedType !== existingType) {
      setValue("selectedType", existingType);
    }
  }, [existingType, selectedType, setValue]);

  /* ===== Initialize bins ===== */
  useEffect(() => {
    if (open && rackLevels) {
      // Handle both data structures: rackLevels.rackLevels or direct rackLevels array
      const levelsArray = rackLevels.rackLevels || rackLevels;
      const initialBins = levelsArray.map((level) => ({
        selected: false,
        level: level.name,
        rackLevelId: level.id,
        binType: "",
        binNumber: "",
      }));
      setValue("bins", initialBins);

      // Pre-select if preselectedLevelId is provided
      if (preselectedLevelId) {
        const preselectedIdx = levelsArray.findIndex(
          (lvl: any) => lvl.id === preselectedLevelId
        );
        if (preselectedIdx !== -1) {
          setValue("selectedRack", preselectedIdx);
          setValue(`bins.${preselectedIdx}.selected`, true);
        }
      }
    }
  }, [open, rackLevels, preselectedLevelId, setValue]);

  // Auto-set type from preselectedType when no existing type is present
  useEffect(() => {
    if (preselectedType && !existingType && selectedType !== preselectedType) {
      setValue("selectedType", preselectedType);
    }
  }, [preselectedType, existingType, selectedType, setValue]);

  /* ===== Submit ===== */
  const onSubmit = (data: FormData) => {
    const selectedBins = data.bins.filter((bin) => bin.selected);

    if (selectedBins.length === 0) {
      toast.error(t("Please select a rack level."));
      return;
    }

    // Handle based on selected type
    if (data.selectedType === "bins") {
      const payload = {
        whAreaId: areaId,
        whRowId: rowId,
        whRackId: rackInstanceId,
        ...(existingType === "bins" && {
          whLevelId: selectedBins[0].rackLevelId,
        }),
        bins: selectedBins.map((bin) => ({
          whLevelId: bin.rackLevelId,
          rackLevel: bin.level,
          binName: bin.binType,
          binNumbers: parseInt(bin.binNumber),
        })),
      };
      console.log("payload", payload);
      if (existingType === "bins") {
        // Use PATCH method for existing levels
        updateRackBins(payload as any, {
          onSuccess: () => {
            toast.success(t("Bins updated successfully!"));
            reset();
            onClose();
            fetchShelves();
          },
          onError: (err: any) =>
            toast.error(t(err?.message || "Failed to update")),
        });
      } else {
        // Use POST method for new levels
        createRackBins(payload as any, {
          onSuccess: () => {
            toast.success(t("Bins created successfully!"));
            reset();
            onClose();
            fetchShelves();
          },
          onError: (err: any) =>
            toast.error(t(err?.message || "Failed to create")),
        });
      }
    } else if (data.selectedType === "pallets") {
      const payload = {
        whAreaId: areaId,
        whRowId: rowId,
        whRackId: rackInstanceId,
        ...(existingType === "pallets" && {
          whLevelId: selectedBins[0].rackLevelId,
        }),
        pallets: selectedBins.map((bin) => ({
          whLevelId: bin.rackLevelId,
          rackLevel: bin.level,
          palletName: bin.binType,
          palletNumbers: parseInt(bin.binNumber),
        })),
      };

      if (existingType === "pallets") {
        // Use PATCH method for existing levels
        updateRackPallets(payload as any, {
          onSuccess: () => {
            toast.success(t("Pallets updated successfully!"));
            reset();
            onClose();
            fetchShelves();
          },
          onError: (err: any) =>
            toast.error(t(err?.message || "Failed to update")),
        });
      } else {
        // Use POST method for new levels
        createRackPallets(payload as any, {
          onSuccess: () => {
            toast.success(t("Pallets created successfully!"));
            reset();
            onClose();
            fetchShelves();
          },
          onError: (err: any) =>
            toast.error(t(err?.message || "Failed to create")),
        });
      }
    }
  };

  if (!open) return null;

  return (
    <>
      {/* <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40"> */}
      <div className="bg-[#F7F6F2] rounded-3xl  flex flex-col">
        {/* Header */}
        <div className="flex items-center justify-between px-4 py-3 border-b">
          <h2 className="text-lg font-medium text-[#212121]">
            {preselectedType === "bins" || existingType === "bins"
              ? t("Add Bins")
              : preselectedType === "pallets" || existingType === "pallets"
                ? t("Add Pallets")
                : t("Add Bins / Pallet")}
          </h2>
          <button
            onClick={onClose}
            className="p-2 rounded-full border-[0.5px] border-[#D2D2D2]"
          >
            <IconX size={20} />
          </button>
        </div>

        <form
          onSubmit={handleSubmit(onSubmit)}
          className="bg-[#F7F6F2] rounded-3xl  flex flex-col shadow-2xl"
        >
          <div className="p-6 space-y-4">
            {!preselectedLevelId && (
              <div>
                <label className="text-sm font-medium">{t("Rack Level")}</label>
                <select
                  {...register("selectedRack", {
                    required: t("Select rack level"),
                  })}
                  disabled={!!preselectedLevelId}
                  onChange={(e) => {
                    const value =
                      e.target.value === "" ? "" : Number(e.target.value);

                    setValue("selectedRack", value);

                    bins?.forEach((_, i) =>
                      setValue(`bins.${i}.selected`, false),
                    );

                    if (value !== "") {
                      setValue(`bins.${value}.selected`, true);
                      setValue(`bins.${value}.binType`, "");
                      setValue(`bins.${value}.binNumber`, "");
                    }
                  }}
                  className={`w-full rounded-xl bg-white border border-gray-200  px-4 py-2 outline-none ${
                    preselectedLevelId ? "bg-gray-100 cursor-not-allowed text-gray-500" : ""
                  }`}
                >
                  <option value="">{t("Select Level")}</option>
                  {bins?.map((bin, idx) => (
                    <option key={idx} value={idx}>
                      {bin.level}
                    </option>
                  ))}
                </select>

                {errors.selectedRack && (
                  <p className="text-red-500 text-xs">
                    {t(errors.selectedRack.message || "")}
                  </p>
                )}
              </div>
            )}

            {!existingType && !preselectedType && (
              <NewSelectInput
                label="Select Type"
                name="selectedType"
                register={register}
                formSetValue={setValue}
                value={watch("selectedType")}
                selectOptions={UserTypeData}
                disabled={selectedIndex === null}
              />
            )}

            {/* Auto-set type when existing type is found */}
            {existingType && selectedType !== existingType && (
              <input
                type="hidden"
                {...register("selectedType")}
                value={existingType}
                onChange={() => setValue("selectedType", existingType)}
              />
            )}

            {selectedIndex !== null && selectedType && (
              <CustomSelect
                namePrefix={`bins.${selectedIndex}.binType`}
                nameNumber={`bins.${selectedIndex}.binNumber`}
                control={control}
                labeltext="Bin"
                options={["1", "2", "3", "4", "5", "10"]}
                error={
                  errors.bins?.[selectedIndex]?.binNumber?.message ||
                  errors.bins?.[selectedIndex]?.binType?.message
                }
                isSelected={true}
              />
            )}
          </div>

          <div className="flex justify-end gap-3 p-4 border-t ">
            <button
              className="px-4 py-2 rounded-full bg-[#FBD037] text-black font-medium hover:bg-yellow-500 transition"
              type="submit"
              disabled={isPending}
            >
              {isPending ? t("Saving...") : t("Create")}
            </button>
          </div>
        </form>
      </div>
      {/* </div> */}
    </>
  );
}
